import './HomePage.css'

import React from 'react'

export default function HomePage() {
  return (
    <div className="home-container">
      <img src="/nugle-clear.png" alt="Nugle Logo" className="logo" />
      <p>reason meets reality</p>
    </div>
  )
}
